import { render, staticRenderFns } from "./DecoFooter.vue?vue&type=template&id=f918dcd2&"
import script from "./DecoFooter.vue?vue&type=script&lang=ts&"
export * from "./DecoFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports